<template>
  <span>
    {{ name || translations.actions.GUEST }}
  </span>
</template>

<script>
import make_translations from "@pdfking/workflow/utils/make_translations"
import proxy from "@pdfking/workflow/utils/proxy"
import merge from "rfuncs/functions/merge"

import user from "../state/user"

export default {
  props: [],
  computed: merge(proxy(user, ["name"]), {
    translations: () => make_translations("actions"),
  }),
}
</script>
